import { mergeStyles, Text } from '@fluentui/react';
import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { uPrinceTheme } from '../../../theme';

const customStyles = {
  control: (_: any, { selectProps: { width } }: any) => ({
    ..._,
    width: width,
    height: 34,
    fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    minHeight: 34,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 1000001 }),
};

const errorMessage = mergeStyles({
  fontSize: 12,
  fontWeight: 400,
  color: 'rgb(164, 38, 44)',
  animationDuration: '0.367s',
  animationFillMode: 'both',
});

const DropdownIndicator = (props: any) => {
  // eslint-disable-next-line no-unused-vars
  const { className, cx, getStyles, innerProps } = props;
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...innerProps}
      style={{ fontSize: 12, paddingRight: 10, paddingTop: 4 }}
    >
      <i
        className={'filter-icon ms-Icon ms-Icon--ChevronDown filter-icon'}
        aria-hidden="true"
      ></i>
    </div>
  );
};

const CustomSearchDropdown = (props: {
  selectedOption: any;
  onChange: (item: any) => void;
  promiseOptions: any;
  // eslint-disable-next-line react/no-unused-prop-types
  defaultInputValue?: string | null;
  required?: boolean;
  validationMessage: string | null;
}) => {
  const [height, setHeight] = useState(50);
  const onMenuOpen = () => {
    setHeight(350);
  };
  const onMenuClose = () => {
    setHeight(50);
  };
  const handleChange = (selectedOption: any, actionMeta: any) => {
    if (actionMeta.action === 'clear') {
      props.onChange(null);
    } else {
      props.onChange(selectedOption);
    }
    onMenuClose();
  };


  return (
    <div style={{ height: height, transition: 'all 0.4s linear' }}>
      { /* <Select*/}
      { /* value={props.selectedOption}*/}
      { /* components={{ DropdownIndicator }}*/}
      { /* styles={customStyles}*/}
      { /* className="reactSelectContainer"*/}
      { /* classNamePrefix="reactSelect"*/}
      { /* onChange={handleChange}*/}
      { /* options={props.options}*/}
      { /* theme={theme => ({*/}
      { /* ...theme,*/}
      { /* borderRadius: 0,*/}
      { /* height: 34,*/}
      { /* minHeight: 34,*/}
      { /* colors: {*/}
      { /* ...theme.colors,*/}
      { /* primary25: uPrinceTheme.palette.themeLight,*/}
      { /* primary: uPrinceTheme.palette.themePrimary,*/}
      { /* neutral20: uPrinceTheme.palette.neutralSecondary,*/}
      { /* neutral30: uPrinceTheme.palette.neutralSecondary,*/}
      { /* },*/}
      { /* })}*/}
      { /* />*/}
      <AsyncSelect
        value={(props.selectedOption) ? props.selectedOption : { value: '', label: '' }}
        // defaultInputValue={
        //   props.defaultInputValue ? props.defaultInputValue : ''
        // }
        components={{ DropdownIndicator }}
        className="reactSelectContainer"
        classNamePrefix="reactSelect"
        styles={customStyles}
        onChange={handleChange}
        // menuPortalTarget={document.body}
        // menuPosition={'fixed'}
        // menuPosition={isFixed ? 'fixed' : 'absolute'}
        required={props.required}
        isClearable={!!(props.selectedOption)}
        menuPlacement={'auto'}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          height: 34,
          minHeight: 34,
          colors: {
            ...theme.colors,
            primary25: uPrinceTheme.palette.themeLight,
            primary: uPrinceTheme.palette.themePrimary,
            neutral20: props.validationMessage
              ? 'rgb(164, 38, 44)'
              : uPrinceTheme.palette.neutralSecondary,
            neutral30: uPrinceTheme.palette.neutralSecondary,
          },
        })}
        cacheOptions
        defaultOptions
        loadOptions={props.promiseOptions}
        onMenuOpen={() => onMenuOpen()}
        onMenuClose={() => onMenuClose()}
        onBlur={() => onMenuClose()}
      />
      {props.validationMessage && (
        <Text className={errorMessage}>{props.validationMessage}</Text>
      )}
    </div>
  );
};

export default CustomSearchDropdown;
